import React from 'react';
import { SaleData } from '../../../types';

interface SaleCompleteProps {
    saleData: SaleData;
    onPrintReceipt: () => void;
    onEmailReceipt: () => void;
    onNewSaleSameVehicle: () => void;
    onXmlUpload: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onNewSale: () => void;
    getPricePerLiter: () => string;
    getFormattedCard: () => string;
}

const PrintIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="6 9 6 2 18 2 18 9"></polyline>
        <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path>
        <rect x="6" y="14" width="12" height="8"></rect>
    </svg>
);

const EmailIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
        <polyline points="22,6 12,13 2,6"></polyline>
    </svg>
);

const DocumentIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
        <polyline points="14 2 14 8 20 8"></polyline>
        <line x1="12" y1="18" x2="12" y2="12"></line>
        <line x1="9" y1="15" x2="15" y2="15"></line>
    </svg>
);

const RefreshIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="23 4 23 10 17 10"></polyline>
        <polyline points="1 20 1 14 7 14"></polyline>
        <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
    </svg>
);

const CarIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M5 17h14l-1-7H6l-1 7z"></path>
        <circle cx="7" cy="17" r="2"></circle>
        <circle cx="17" cy="17" r="2"></circle>
        <line x1="5" y1="10" x2="19" y2="10"></line>
    </svg>
);

export const SaleComplete: React.FC<SaleCompleteProps> = ({
    saleData,
    onPrintReceipt,
    onEmailReceipt,
    onNewSaleSameVehicle,
    onXmlUpload,
    onNewSale,
}) => {
    return (
        <div className="sale-complete">
            <h2 className="sale-success-title">
                <span className="success-icon">✓</span>
                Venda Processada com Sucesso!
            </h2>
            <p className="sale-success-description">
                Escolha o próximo passo. Você pode emitir/compartilhar o comprovante, anexar a NF/XML ou iniciar uma nova venda.
            </p>

            <div className="action-sections">
                <div className="action-section">
                    <h3 className="section-title">COMPROVANTE</h3>
                    <div className="action-buttons-group">
                        <button className="action-btn print-btn" onClick={onPrintReceipt}>
                            <PrintIcon />
                            Imprimir Comprovante
                        </button>
                        <div className="email-btn-wrapper">
                            <button className="action-btn email-btn" disabled title="Funcionalidade em desenvolvimento">
                                <EmailIcon />
                                Enviar por E-mail
                            </button>
                            <span className="email-coming-soon">Em breve</span>
                        </div>
                    </div>
                </div>

                <div className="action-section">
                    <h3 className="section-title">OPERAÇÕES</h3>
                    <div className="action-buttons-group">
                        {saleData.xmlAttached ? (
                            <button className="action-btn xml-btn disabled" disabled>
                                <DocumentIcon />
                                XML Anexado
                            </button>
                        ) : (
                            <label className="action-btn xml-btn">
                                <DocumentIcon />
                                Anexar NF/XML
                                <input
                                    type="file"
                                    accept=".xml"
                                    onChange={onXmlUpload}
                                    style={{ display: 'none' }}
                                />
                            </label>
                        )}
                        <button className="action-btn new-sale-full-btn" onClick={onNewSale}>
                            <RefreshIcon />
                            Nova Venda
                        </button>
                        <button className="action-btn new-sale-btn" onClick={onNewSaleSameVehicle}>
                            <CarIcon />
                            Nova Venda para o Veículo
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};
